const isMaintenanceModeActive = ({
  settings,
  now,
}: {
  settings: MaintenanceMode.Settings | undefined;
  now: Date;
}): boolean => {
  if (!settings || !settings.isEnabled) {
    return false;
  }

  if (settings.endsOn === null) {
    return true;
  }

  return new Date(settings.endsOn).getTime() > now.getTime();
};

export default isMaintenanceModeActive;
